import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { arraysHaveSameElements } from '../../DashboardGridIndex.jsx';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';

function DatasetSizeSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const colorScheme = useSelector(state => state.dashboard.colorScheme, arraysHaveSameElements);
    const dataset_mode = useSelector(state => state.dashboard.widgets[widgetId].settings?.dataset_mode);
    const datasets = useSelector(state => state.dashboard.widgets[widgetId].settings?.datasets) || [];

    const addDataset = () => {
        setAttribute('settings.datasets', [...datasets, {
            dataset_id: "",
            name_item: "",
            value: "",
            target: "",
            background_color: colorScheme[datasets.length % colorScheme.length],
            id: StringHelper.random(8),
        }])
    };

    return (
        dataset_mode != 'grouped' ? (
            <button className="btn btn-primary" onClick={addDataset}>
                {I18n.t("add_dataset")}
            </button>
        ) : null
    )
}

export default DatasetSizeSettings;
